<template>
  <div id="interview-date-selector" v-if="value && error">
    <div class="sub-header" v-if="value.data.length > 1">
      <label :for="option.value" class="interview-together-radio flex-center" :class="{ 'first': option.value === 1, 'highlight': option.value === value.interview_together }" v-for="option in interviewTogetherOption" :key="option.value">
        <input type="radio" :id="option.value" :value="option.value" v-model="value.interview_together" @change="switchInterviewTogether">
        {{option.text}}
      </label>
    </div>
    <el-form :model="value" ref="dataForm">
      <template v-if="value.interview_together === 0">
        <div v-for="(item, idx) in value.data" :key="idx">
          <div class="applicant-info" :key="item.order_applicant_id">
            <span class="applicant-name">{{order.applicant[idx].applicant_name}}</span>
            <span class="applicant-identity">{{order.applicant[idx].identity}}</span>
          </div>

          <div class="pos-date-box">
            <div class="pos-box" v-if="!cityDateEmpty">
              <div class="text-label">赴馆城市</div>
              <el-select v-model="item.embassy_district_id" placeholder="请选择" class="pos-selector" @change="(value) => handleCityChange(value, idx)">
                <el-option
                  v-for="city in earlistDate.city_date"
                  :key="city.embassy_district_id"
                  :label="city.embassy_district_name"
                  :value="city.embassy_district_id">
                </el-option>
              </el-select>
            </div>

            <div class="date-box">
              <div class="date-text-label">赴馆日期</div>
              <el-radio-group class="date-choice-radio-group" v-model="item.date_choice" :key="idx">
                <el-radio class="date-choice-radio" :label="0" :disabled="!item.embassy_district_id && !cityDateEmpty">
                  <div class="picker-radio-item">
                    <span class="picker-label">最佳赴馆日期前往 </span>
                    <span v-if="value.data[0].date_choice === 0 && (item.embassy_district_id || cityDateEmpty)">
                      <base-popover-with-close
                        ref="basePopover"
                        position="top"
                        width="300px"
                        trigger="hover"
                        :show-close-icon="false"
                        :content="getPopoverContent">
                        <img class="icon-tooltip"  src="https://o.666visa.cn/static/ssqpeer/common/icon_tooltip.png" alt="">
                      </base-popover-with-close>
                    </span>
                  </div>
                </el-radio>
                <template v-if="item.date_choice === 0 && (item.embassy_district_id || cityDateEmpty)">
                  <!-- <div class="cue">最早可预约 {{earlistDateDepartFormate(item.embassy_district_id) && earlistDateDepartFormate(item.embassy_district_id)[1]}}月{{earlistDateDepartFormate(item.embassy_district_id) && earlistDateDepartFormate(item.embassy_district_id)[2]}}日。由于使馆开放预约时间不稳定，请选择3个方便赴馆的时间，我们将优先预约您选择的最早日期。</div> -->
                  <div class="date-picker-container">
                    <div class="date-picker-item" v-for="(preferredDate, dateIndex) in item.preferred_date" :key="preferredDate.date">
                      <div class="picker-label">最佳赴馆日期{{dateIndex + 1}}</div>
                      <holiday-date-picker style="width: 212px;" :depart-date="toValidDate(preferredDate.date)" :min-disabled-date="minDisableDate(earlistDateDepart(item.embassy_district_id))" :max-date="maxDateDepart(item.embassy_district_id)" :holiday-date-arr="holiday" :unselectable="item.preferred_date" :options="{ narrow: true }" :error="error[idx][0][dateIndex]" :show-early="false" :earlistDate="earlistDateDepart(item.order_applicant_id)" @input="onDateChange(idx, dateIndex, arguments[0])" />
                      <el-select v-model="preferredDate.period" class="period-select" v-show="toValidDate(preferredDate.date)">
                        <el-option :label="periodName" :value="parseInt(index)" v-for="(periodName, index) in ['整天', '上午', '下午']" :key="'period_' + index"></el-option>
                      </el-select>
                    </div>
                  </div>
                </template>
                <!-- <el-radio class="date-choice-radio" :label="1" :disabled="!item.embassy_district_id && !cityDateEmpty">近30天内任何时间都方便</el-radio>
                <el-radio class="date-choice-radio" :label="2" :disabled="!item.embassy_district_id && !cityDateEmpty">近30天内均无法前往</el-radio> -->
                <!-- <el-input v-show="item.date_choice === 2" type="textarea" :rows="4" class="text-area" :class="{ error: error[idx][2] }" placeholder="请说明其它方便赴馆的具体时间" :maxlength="100" v-model="item.other_date">
                </el-input> -->
                <el-radio class="date-choice-radio" :label="3" :disabled="!item.embassy_district_id && !cityDateEmpty">预计出行日期之前均方便</el-radio>
                <el-radio class="date-choice-radio" :label="4" :disabled="!item.embassy_district_id && !cityDateEmpty">30天后均方便</el-radio>
              </el-radio-group>
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="applicant-info" v-if="order.applicant.length > 1">
          <span class="applicant-name">{{joinedName}}</span>
        </div>
        <div class="pos-date-box">
          <div class="pos-box" v-if="!cityDateEmpty">
            <div class="text-label">赴馆城市</div>
            <el-select v-model="value.data[0].embassy_district_id" placeholder="请选择" class="pos-selector" @change="(value) => handleCityChange(value, 0)">
              <el-option
                v-for="item in earlistDate.city_date"
                :key="item.embassy_district_id"
                :label="item.embassy_district_name"
                :value="item.embassy_district_id">
              </el-option>
            </el-select>
          </div>
          <div class="date-box">
            <div class="date-text-label">赴馆日期</div>
            <el-radio-group class="date-choice-radio-group" v-model="value.data[0].date_choice">
              <el-radio class="date-choice-radio" :label="0" :disabled="!value.data[0].embassy_district_id && !cityDateEmpty">
                <div class="picker-radio-item">
                    <span class="picker-label">最佳赴馆日期前往</span>
                    <span v-if="value.data[0].date_choice === 0 && (value.data[0].embassy_district_id || cityDateEmpty)">
                      <base-popover-with-close
                        ref="basePopover"
                        position="top"
                        width="300px"
                        trigger="hover"
                        :show-close-icon="false"
                        :content="getPopoverContent">
                        <img class="icon-tooltip"  src="https://o.666visa.cn/static/ssqpeer/common/icon_tooltip.png" alt="">
                      </base-popover-with-close>
                    </span>
                  </div>
              </el-radio>
              <template v-if="value.data[0].date_choice === 0 && (value.data[0].embassy_district_id || cityDateEmpty)">
                <!-- <div class="cue">最早可预约 {{earlistDateTogetherFormate() && earlistDateTogetherFormate()[1]}}月{{earlistDateTogetherFormate() && earlistDateTogetherFormate()[2]}}日。由于使馆开放预约时间不稳定，请选择3个方便赴馆的时间，我们将优先预约您选择的最早日期。</div> -->
                <div class="date-picker-container">
                  <div class="date-picker-item" v-for="(preferredDate, dateIndex) in value.data[0].preferred_date" :key="preferredDate.date">
                    <span class="picker-label">最佳赴馆日期{{dateIndex + 1}}</span>
                    <holiday-date-picker style="width: 212px;" :depart-date="toValidDate(preferredDate.date)" :min-disabled-date="minDisableDate(earlistDateTogether())" :max-date="maxDateTogether" :holiday-date-arr="holiday" :unselectable="value.data[0].preferred_date" :options="{ narrow: true }" :error="error[0][0][dateIndex]" @input="onDateChange(0, dateIndex, arguments[0])" />
                    <el-select v-model="preferredDate.period" class="period-select" v-show="toValidDate(preferredDate.date)">
                      <el-option :label="periodName" :value="parseInt(index)" v-for="(periodName, index) in ['整天', '上午', '下午']" :key="'period_' + index"></el-option>
                    </el-select>
                  </div>
                </div>
              </template>
              <!-- <el-radio class="date-choice-radio" :label="1" :disabled="!value.data[0].embassy_district_id && !cityDateEmpty">近30天内任何时间都方便</el-radio>
              <el-radio class="date-choice-radio" :label="2" :disabled="!value.data[0].embassy_district_id && !cityDateEmpty">近30天内均无法前往</el-radio>
              <el-input v-show="value.data[0].date_choice === 2" type="textarea" :rows="4" :maxlength="100" class="text-area" :class="{ error: error[0][2]}" placeholder="请说明其它方便赴馆的具体时间" v-model="value.data[0].other_date">
              </el-input> -->

              <el-radio class="date-choice-radio" :label="3" :disabled="!value.data[0].embassy_district_id && !cityDateEmpty">预计出行日期之前均方便</el-radio>
              <el-radio class="date-choice-radio" :label="4" :disabled="!value.data[0].embassy_district_id && !cityDateEmpty">30天后均方便</el-radio>
            </el-radio-group>
          </div>
        </div>
      </template>
    </el-form>
  </div>
</template>

<script>
import dateUtils from '../libs/date-util';
import DatePlus from '../libs/date-plus';
import holidayDatePicker from './holiday-date-picker';
import BasePopoverWithClose from '../components/common/popover/base-popover-with-close.vue';

export default {
  props: ['order', 'value', 'holiday', 'error', 'earlistDate', 'cityDateEmpty'],
  components: {
    holidayDatePicker,
    BasePopoverWithClose,
  },
  data() {
    return {
      interviewTogetherOption: [
        {
          value: 1,
          text: '申请人预约相同时间',
        },
        {
          value: 0,
          text: '申请人预约不同时间',
        },
      ],
      originData: null,
      maxDate: null,
    };
  },
  computed: {
    joinedName() {
      return this.order.applicant.map(item => item.applicant_name).join('、');
    },
    minDate() {
      const paddingDayNum = this.order.need_delivery > 0 ? 2 : 4;
      return dateUtils.getClosestDate(
        paddingDayNum,
        this.holiday.map(({ date }) => date),
      );
    },
    earlistDateByCityTogether() {
      if (this.earlistDate.city_date && this.earlistDate.city_date.length) {
        const chooseItem = this.earlistDate.city_date.filter(item => item.embassy_district_id === this.value.data[0].embassy_district_id).pop();
        return chooseItem && chooseItem.earliest_date;
      }
      return this.earlistDate.default_date;
    },
    maxDateTogether() {
      const currentDatePlusTo = new DatePlus(
        new Date(this.earlistDateByCityTogether),
      );
      return currentDatePlusTo && currentDatePlusTo.nextMonth.date;
    },
  },
  mounted() {
    this.validateInitialEmbassyDistrictIds();
  },
  methods: {
    getPopoverContent() {
      const dateParts = this.earlistDateTogetherFormate();
      if (dateParts && dateParts.length >= 2) {
        return `最早可预约 <span style="font-size:14px;font-weight: 500;">${dateParts[1]}月${dateParts[2]}日</span>
               <div style="width:266px;border-bottom:1px dashed #fff;margin:6px 0;opacity:0.5;"></div>
              由于使馆开放预约时间不稳定，请选择3个方便赴<br/>馆的时间，我们将优先预约您选择的最早日期。`;
      }
      return `最早可预约日期暂不可用<br/>
            由于使馆开放预约时间不稳定，请选择3个方便赴<br/>馆的时间，我们将优先预约您选择的最早日期。`;
    },
    // 获取最早赴馆时间（分开）
    earlistDateDepart(cityId) {
      if (this.earlistDate.city_date && this.earlistDate.city_date.length) {
        const chooseItem = this.earlistDate.city_date.filter(item => item.embassy_district_id === cityId).pop();
        return chooseItem && chooseItem.earliest_date;
      }
      return this.earlistDate.default_date;
    },
    // 格式化最早赴馆时间（分开）
    earlistDateDepartFormate(cityId) {
      return this.earlistDateDepart(cityId).split('-');
    },
    maxDateDepart(cityId) {
      let curDate;
      if (this.earlistDate.city_date && this.earlistDate.city_date.length) {
        const chooseItem = this.earlistDate.city_date.filter(item => item.embassy_district_id === cityId).pop();
        curDate = chooseItem.earliest_date;
      } else {
        curDate = this.earlistDate.default_date;
      }
      const currentDatePlusDe = new DatePlus(new Date(curDate));
      return currentDatePlusDe.nextMonth.date;
    },
    // holiday-date-picker组件最早赴馆时间
    minDisableDate(date) {
      return new Date(new Date(date).getTime() - 86400000);
    },
    // 格式化最早赴馆时间(一起）
    earlistDateTogetherFormate() {
      return this.earlistDateByCityTogether && this.earlistDateByCityTogether.split('-');
    },
    // 获取最早赴馆时间(一起）
    // earlistDateTogether() {
    //   return this.earlistDate.applicant
    //   // 获取当前选中申请人
    //     .filter(item => this.order.applicant.map(item => item.order_applicant_id).indexOf(item.order_applicant_id) > -1)
    //     // 获取申请人最早赴馆时间
    //     .map(item => new Date(item.earliest_date))
    //     // 对事件数组进行升序排序，获取第一个便是最早赴馆时间
    //     .sort((a, b) => (a < b ? 1 : -1))[0].format('yyyy-MM-dd');
    // },
    earlistDateTogether() {
      return this.earlistDateByCityTogether;
    },
    switchInterviewTogether(e) {
      this.$emit('switchInterviewTogether', +e.target.value);
    },
    onDateChange(idx, dateIndex, date) {
      const dateStr = date.format('yyyy-MM-dd');
      const { preferred_date } = this.value.data[idx];
      preferred_date[dateIndex].date = dateStr;
      preferred_date[dateIndex].period = 0;
    },

    toValidDate(date) {
      // const minDateStr = this.minDate.format('yyyy-MM-dd');
      if (!date) return null;
      return new Date(date);
    },

    cityChange(cityVal, itemIndex) {
      const makePreferredDate = () => [{ date: null, period: 0 }, { date: null, period: 0 }, { date: null, period: 0 }];
      const emptyData = {
        other_date: '',
        preferred_date: makePreferredDate(),
      };
      this.value.data = this.value.data.map((item, index) => {
        if (index === itemIndex) {
          return { ...item, ...emptyData };
        }
        return item;
      });
    },

    validateInitialEmbassyDistrictIds() {
      this.value.data.forEach((item, idx) => {
        const isValid = this.earlistDate.city_date.some(
          city => city.embassy_district_id === item.embassy_district_id,
        );
        if (!isValid) {
          this.$set(item, 'embassy_district_id', undefined);
        }
      });
    },

    handleCityChange(value, idx) {
      // 检查当前选择的值是否存在于 earlistDate.city_date 中
      const isValid = this.earlistDate.city_date.some(city => city.embassy_district_id === value);
      if (!isValid) {
        // 如果不存在，则将值重置为空
        this.$set(this.value.data[idx], 'embassy_district_id', null);
      } else {
        // 如果合法，触发原有的 cityChange 方法
        this.cityChange(value, idx);
      }
    },

  },
  created() {
  },
};
</script>
<style lang="less">
.date-choice-radio {
  .el-radio__label {
    font-size: 14px;
    padding-left: 10px;
  }
  .picker-radio-item{
    display: flex;
    justify-content: flex-start;
    gap: 4px;
    height: 20px;
    align-items: center;
    .picker-label{
      font-size: 14px;
      color: #2F333D;
    }
    .icon-tooltip{
      display: block;
      width: 14px;
      height: 14px;
    }
  }
}
.text-area {
  .el-textarea__inner {
    padding: 5px 10px;
    line-height: 1.4;
  }

  &.error {
    .el-textarea__inner {
      border-color: #f66878;
    }
  }
}

.el-select .el-input .el-input__icon {
  color: #97989d !important;
}
.period-select {
  width: 90px;
  margin-left: 10px;
}
</style>

<style lang="less" scoped>
@import "../assets/less/variable.less";
.sub-header {
  // height: 80px;
  display: flex;
  align-items: center;
  padding-bottom: 22px;
  border-bottom: 1px dashed #E9EEF2;
}
.applicant-info {
  margin-top: 20px;
  .applicant-name {
    font-size: 16px;
    color: #333;
    font-weight: bold;
  }
  .applicant-identity {
    font-size: 14px;
    color: #777;
    margin-left: 10px;
  }
}


.date-picker-container {
  margin: 10px 0 0 30px;
  height: 180px;
  background-color: #fbfbfb;
  padding: 20px 20px 0;
  .date-picker-item {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
  }
  .picker-label {
    font-size: 14px;
    color: #333;
    margin-right: 20px;
  }
}

.interview-together-radio {
  width: 184px;
  height: 40px;
  border-radius: 4px;
  border: 1px solid #ddd;
  font-size: 16px;
  color: #6f6f6f;
  cursor: pointer;
  &.first {
    margin: 0 20px 0 0;
  }
  &.highlight {
    border-color: @blue;
    color: @blue;
    background: url(../assets/imgs/recharge-gou.png) no-repeat right top;
  }
  input[type="radio"] {
    display: none;
  }
}
.date-choice-radio-group {
  display: block;
  padding-bottom: 20px;
  border-bottom: 1px solid #f0f0f0;
  &:last-child {
    border-bottom: none;
  }
}
.date-choice-radio {
  display: flex;
  margin-left: 0;
  margin-top: 20px;
  width: 350px;
}
.text-area {
  margin: 10px 0 0 30px;
  width: 600px;
}
.pos-date-box{
  .pos-box{
    display: flex;
    align-items: center;
    margin-top: 20px;
  }
  .date-box{
    display: flex;
  }
  .text-label{
    font-size: 16px;
    margin-right: 20px;
  }
  .date-text-label{
    .text-label;
    padding-top: 19px;
  }
}

</style>




// WEBPACK FOOTER //
// src/components/interview-date-select-form.vue